import { Box, Button, Divider, HStack, IconButton, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, VStack } from "@chakra-ui/react";
import { Close, EditOutlined } from "@mui/icons-material";
import React from "react";
import { useWebSocket } from "../../../internal/messaging/WebSocketContext.js";
import TaskDetails from "./TaskDetails";
import TaskStages from "./TaskStages";
import ResponsePreferences from "./ResponsePreferences";
import ExportSettings from "./ExportSettings";
import apiClient from "../../../clients/apiClient.js";

const NewTaskModal = ({ isTaskOpen, onClose }) => {
    return (
        <Modal
            isOpen={isTaskOpen}
            onClose={onClose}
            isCentered
            size="lg"
            motionPreset="slideInBottom"
        >
            <ModalOverlay
                bg="blackAlpha.300"
                backdropFilter="blur(1px)"
            />
            <TaskModal onClose={onClose} />
        </Modal>
    );
}

const TaskModal = ({ onClose }) => {
    const { firstChatMessage } = useWebSocket();
    const [selectedTaskType, setSelectedTaskType] = React.useState('');
    const [tagKey, setTagKey] = React.useState('');
    const [tagValue, setTagValue] = React.useState('');
    const [allFilterTags, setAllFilterTags] = React.useState([]);
    const [htmlChunks, setHtmlChunks] = React.useState([]);
    const [rawChunks, setRawChunks] = React.useState([]);

    const [currentStage, setCurrentStage] = React.useState("task details")

    const [taskName, setTaskName] = React.useState('');
    const [taskType, setTaskType] = React.useState('');
    const [taskValue, setTaskValue] = React.useState('');
    const [date, setDate] = React.useState('');
    const [time, setTime] = React.useState('');
    const [timezone, setTimezone] = React.useState('');
    const [selectedFile, setSelectedFile] = React.useState(null);
    const [documentType, setDocumentType] = React.useState('');
    const [currency, setCurrency] = React.useState('');

    const [items, setItems] = React.useState([
        "Bid/No-Bid",
        "Pre-fill",
        "Audit",
        "Review and Collaborate",
        "Export",
        "Outcome"
    ]);

    const [tone, setTone] = React.useState(null);
    const [answerLength, setAnswerLength] = React.useState(null);
    const [tags, setTags] = React.useState([]);
    const [conversationValue, setConversationValue] = React.useState('');
    const [isConversationEditedOnce, setIsConversationEditedOnce] = React.useState(false);
    const [language, setLanguage] = React.useState('english');

    const [exportIn, setExportIn] = React.useState("source");
    const [saveToLibrary, setSaveToLibrary] = React.useState("yes");

    React.useEffect(() => {
        if (selectedTaskType === 'RFP') {
            const promptText = 'Hi Thalamus, can you please fill the attached RFP';
            setConversationValue('');
            let index = 0;
            if (window.typingInterval) {
                clearInterval(window.typingInterval);
            }
            window.typingInterval = setInterval(() => {
                const currValue = index;
                setConversationValue((prev) => prev + promptText[currValue]);
                index++;
                if (index === promptText.length) {
                    clearInterval(window.typingInterval);
                }
            }, 25); // Adjust the speed of the typing animation here
        } else if (selectedTaskType === 'proposal') {
            const promptText = 'Hi Thalamus, can you please fill the attached proposal';
            setConversationValue('');
            let index = 0;
            if (window.typingInterval) {
                clearInterval(window.typingInterval);
            }
            window.typingInterval = setInterval(() => {
                const currValue = index;
                setConversationValue((prev) => prev + promptText[currValue]);
                index++;
                if (index === promptText.length) {
                    clearInterval(window.typingInterval);
                }
            }, 25); // Adjust the speed of the typing animation here
        } else if (selectedTaskType === 'rfi') {
            const promptText = 'Hi Thalamus, can you please fill the attached RFI';
            setConversationValue('');
            let index = 0;
            if (window.typingInterval) {
                clearInterval(window.typingInterval);
            }
            window.typingInterval = setInterval(() => {
                const currValue = index;
                setConversationValue((prev) => prev + promptText[currValue]);
                index++;
                if (index === promptText.length) {
                    clearInterval(window.typingInterval);
                }
            }, 25); // Adjust the speed of the typing animation here
        } else if (selectedTaskType === 'search') {
            const promptText = 'Hi Thalamus, can you please search for a file which contains ...';
            setConversationValue('');
            let index = 0;
            if (window.typingInterval) {
                clearInterval(window.typingInterval);
            }
            window.typingInterval = setInterval(() => {
                const currValue = index;
                setConversationValue((prev) => prev + promptText[currValue]);
                index++;
                if (index === promptText.length) {
                    clearInterval(window.typingInterval);
                }
            }, 25); // Adjust the speed of the typing animation here
        }
        
    }, [selectedTaskType]);

    const handleAttachFile = () => {
        const input = document.createElement('input');
        input.type = 'file';

        input.onchange = (event) => {
            const file = event.target.files[0];
            if (file) {
                console.log('Selected file:', file);
                setSelectedFile(file);
            }
        };

        input.click();
    };

    const handleDiscardFile = () => {
        setSelectedFile(null);
    };

    const handleAddTask = async () => {
        let fileData;
        if (selectedFile) {
            fileData = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = (error) => reject(error);
                reader.readAsDataURL(selectedFile);
            });
        }

        const fileNewData = fileData;
        const fileType = selectedFile?.type
        console.log('fileNewData', fileNewData);
        console.log('file type in send message', fileType);

        const myText = {
            text: conversationValue,
            files: selectedFile
            ? [
                {
                    name: selectedFile.name,
                    data: fileNewData,
                    type: fileType,
                },
                ]
            : [],
            filter_tags: allFilterTags ? allFilterTags.map((tag) => ({
                tag_key: tag.tag_key,
                tag_value: tag.tag_value,
            })) : [],
        };

        // this is http call
        firstChatMessage(myText, taskName);

        setSelectedFile(null);
        onClose();
    };

    const addTagToFilter = () => {
        if (tagKey.trim() && tagValue.trim()) {
            setAllFilterTags((prev) => [...prev, { tag_key: tagKey, tag_value: tagValue }]);
            setTagKey('');
            setTagValue('');
        }
    }

    const removeTagToFilter = (index) => {
        setAllFilterTags((prev) => prev.filter((_, i) => i !== index));
    }

    const canProceedToNextStage = () => {
        if (currentStage === "task details") {
            return isTaskStagesUnlocked();
        } else if (currentStage === "task stages") {
            return isResponsePreferencesUnlocked();
        } else if (currentStage === "response preferences") {
            return isExportSettingsUnlocked();
        } else if (currentStage === "export settings") {
            return isCreateTaskUnlocked();
        }

        return false
    }

    const isTaskStagesUnlocked = () => {
        if (taskName.trim() == '') {
            return false
        }

        if (selectedFile == null) {
            return false
        }

        return true;
    }

    const isResponsePreferencesUnlocked = () => {
        if (!isTaskStagesUnlocked()) {
            return false
        }
        
        return true
    }

    const isExportSettingsUnlocked = () => {
        if (!isResponsePreferencesUnlocked()) {
            return false
        }

        if (conversationValue.trim() == '') {
            return false
        }

        return true
    }

    const isCreateTaskUnlocked = () => {
        if (!isExportSettingsUnlocked()) {
            return false
        }

        return true;
    }

    const startAnnotation = () => {
        apiClient.post('/annotation/upload-file').then((response1) => {
            console.log("Response from upload file", response1);
            if (response1?.data?.success) {
                const formData = selectedFile;

                fetch(response1.data?.upload_file?.upload_url, {
                    method: "PUT",
                    body: formData,
                }).then((response2) => {
                    if (response2.ok) {
                        apiClient.post('/annotation/start-annotation', {
                            file: {
                                file_id: response1.data?.upload_file?.file_id,
                            }
                        }).then((response3) => {
                            console.log("Response from start annotation", response3);
                            apiClient.post('/annotation/get-file-chunk', {
                                file: {
                                    file_id: response1.data?.upload_file?.file_id,
                                },
                                chunk_offset_start: 1,
                                chunk_offset_end: response3.data?.total_chunks,
                            }).then((response4) => {
                                setRawChunks(response4.data?.chunks);
                            })
                        })
                    }
                })
            }
        })
    }

    React.useEffect(() => {
        const loadChunks = async () => {
          const fetchedChunks = [];
    
          for (const chunk of rawChunks) {
            try {
              const res = await fetch(chunk.chunk_url);
              const html = await res.text();
              fetchedChunks.push(html);
            } catch (err) {
              console.error("Failed to fetch chunk:", chunk.chunk_url, err);
            }
          }
    
          setHtmlChunks(fetchedChunks);
        };
    
        loadChunks();

    }, [rawChunks]);

    return (
        <ModalContent
            w={"690px"}
            maxW={"690px"}
        >
            <ModalHeader>
                <HStack
                    justifyContent="space-between"
                    alignItems="center"
                    width="100%"
                >
                    <Text
                        justifySelf={"flex-start"}
                        fontSize="xl"
                        fontWeight="bold"
                        fontFamily={"sans-serif"}
                        color={"#1d1d1d"}
                    >New task</Text>
                    <IconButton
                        justifySelf={"flex-end"}
                        sx={{ 
                            paddingX:0, 
                            paddingY:0,
                            backgroundColor:"transparent",
                            "&:hover":{backgroundColor:"transparent"}
                        }}
                        icon={
                            <Close sx={{ padding:0, fontSize: 24, color: "#5d5d5d" }}/>
                        }
                        onClick={onClose}
                    />
                </HStack>
            </ModalHeader>
            <ModalBody
                width={"100%"}
                maxW={"100%"}
            >
                <HStack
                    width={"588px"}
                    height={"36px"}
                    gap={0}
                >
                    <Box
                        borderBottom={"3px solid"}
                        borderColor={currentStage == "task details" ? "#2584FD" : "#e5e5e5"}
                        height={"100%"}
                        paddingRight={"8px"}
                        w={"117px"}
                        display="flex"
                        justifyContent="center"
                        _hover={{ cursor: "pointer" }}
                        onClick={() => setCurrentStage("task details")}
                    >
                        Task details
                    </Box>
                    <Box
                        borderBottom={"3px solid"}
                        borderColor={currentStage == "task stages" ? "#2584FD" : "#e5e5e5"}
                        height={"100%"}
                        paddingX={"8px"}
                        width={"123px"}
                        display="flex"
                        justifyContent="center"
                        _hover={{ cursor: isTaskStagesUnlocked() ? "pointer" : "not-allowed" }}
                        onClick={() => isTaskStagesUnlocked() && setCurrentStage("task stages")}
                        opacity={isTaskStagesUnlocked() ? 1 : 0.5}
                    >
                        Task stages
                    </Box>
                    <Box
                        borderBottom={"3px solid"}
                        borderColor={currentStage == "response preferences" ? "#2584FD" : "#e5e5e5"}
                        height={"100%"}
                        paddingX={"8px"}
                        width={"209px"}
                        display="flex"
                        justifyContent="center"
                        _hover={{ cursor: isResponsePreferencesUnlocked() ? "pointer" : "not-allowed" }}
                        onClick={() => isResponsePreferencesUnlocked() && setCurrentStage("response preferences")}
                        opacity={isResponsePreferencesUnlocked() ? 1 : 0.5}
                    >
                        Response preferences
                    </Box>
                    <Box
                        borderBottom={"3px solid"}
                        borderColor={currentStage == "export settings" ? "#2584FD" : "#e5e5e5"}
                        height={"100%"}
                        paddingLeft={"8px"}
                        w={"139px"}
                        display="flex"
                        justifyContent="center"
                        _hover={{ cursor: isExportSettingsUnlocked() ? "pointer" : "not-allowed" }}
                        onClick={() => isExportSettingsUnlocked() && setCurrentStage("export settings")}
                        opacity={isExportSettingsUnlocked() ? 1 : 0.5}
                    >
                        Export settings
                    </Box>
                </HStack>
                <Box
                    maxHeight={"612px"}
                    marginTop={"32px"}
                    overflowY={"auto"}
                    overflowX={"hidden"}
                    data-scrollable="true"
                    w={"100%"}
                    maxW={"100%"}
                >
                    {
                        currentStage === "task details" ? <TaskDetails 
                            taskName={taskName} setTaskName={setTaskName}
                            date={date} setDate={setDate}
                            taskType={taskType} setTaskType={setTaskType}
                            taskValue={taskValue} setTaskValue={setTaskValue}
                            timezone={timezone} setTimezone={setTimezone}
                            time={time} setTime={setTime}
                            selectedFile={selectedFile} setSelectedFile={setSelectedFile}
                            documentType={documentType} setDocumentType={setDocumentType}
                            currency={currency} setCurrency={setCurrency}
                        /> : 
                        currentStage === "task stages" ? <TaskStages
                            items={items} setItems={setItems}
                        /> : 
                        currentStage === "response preferences" ? <ResponsePreferences
                            tone={tone} setTone={setTone}
                            answerLength={answerLength} setAnswerLength={setAnswerLength}
                            tags={tags} setTags={setTags}
                            conversationValue={conversationValue} setConversationValue={setConversationValue}
                            isConversationEditedOnce={isConversationEditedOnce} setIsConversationEditedOnce={setIsConversationEditedOnce}
                            language={language} setLanguage={setLanguage}
                            taskType={taskType}
                        /> : 
                        currentStage === "export settings" ? <ExportSettings
                            exportIn={exportIn} setExportIn={setExportIn}
                            saveToLibrary={saveToLibrary} setSaveToLibrary={setSaveToLibrary}
                            startAnnotation={startAnnotation}
                            htmlChunks={htmlChunks}
                        /> : null
                    }
                </Box>
            </ModalBody>
            <ModalFooter
                height={"52px"}
                marginBottom={"8px"}
            >
                <VStack width={"100%"}>
                    <Divider />
                    <HStack
                        gap={0}
                        width={"100%"}
                        display={"flex"}
                        justifyContent="flex-end"
                    >
                        <Button
                            bgColor={"transparent"}
                            color={"#000"}
                            _hover={{ bgColor: "#F4F4F4" }}
                            onClick={onClose}
                            height={"32px"}
                            width={"92px"}
                            fontSize={"14px"}
                            fontWeight={500}
                        >
                            Cancel
                        </Button>
                        {
                            currentStage !== "export settings" ? (
                                <Button
                                    bgColor={"#2584FD"}
                                    color={"#fff"}
                                    _hover={{ bgColor: "#2584FD" }}
                                    onClick={() => (
                                        currentStage === "task details" ? setCurrentStage("task stages") :
                                        currentStage === "task stages" ? setCurrentStage("response preferences") :
                                        currentStage === "response preferences" ? setCurrentStage("export settings") : null
                                    )}
                                    isDisabled={!canProceedToNextStage()}
                                    borderRadius={"4px"}
                                    height={"32px"}
                                    width={"92px"}
                                    fontSize={"14px"}
                                    fontWeight={500}
                                    _disabled={{
                                        backgroundColor: "#D5D5D5",
                                    }}
                                >
                                    Next
                                </Button>
                            ) : (

                                <Button
                                    bgColor={"#2584FD"}
                                    color={"#fff"}
                                    _hover={{ bgColor: "#2584FD" }}
                                    onClick={() => (
                                        handleAddTask()
                                    )}
                                    isDisabled={!canProceedToNextStage()}
                                    borderRadius={"4px"}
                                    height={"32px"}
                                    width={"92px"}
                                    fontSize={"14px"}
                                    fontWeight={500}
                                    _disabled={{
                                        backgroundColor: "#D5D5D5",
                                    }}
                                >
                                    Create task
                                </Button>
                            )
                        }
                    </HStack>
                </VStack>
            </ModalFooter>
        </ModalContent>
    );
}


export default NewTaskModal;